<mat-form-field appearance="outline" [formGroup]="formGroup">
  <mat-label>{{placeholderText}}</mat-label>
  <input matInput placeholder="{{placeholderText}}" formControlName="{{fieldName}}">
  <mat-error>
    <app-validation-partial
        [formGroup]="formGroup"
        [fieldName]="fieldName"
    ></app-validation-partial>
  </mat-error>
</mat-form-field>
<a mat-raised-button color="'primary'" (click)="searchAbnAcn()" *ngIf="!loadingResults">Search</a>
<mat-spinner [diameter]="30" [color]="secondary" [strokeWidth]="3" *ngIf="loadingResults"></mat-spinner>
